import FullScreenIcon from "../../../atom/icons/FullScreenIcon";
import ExitFullScreenIcon from "../../../atom/icons/ExitFullScreenIcon";
import clsx from "clsx";
import { Dispatch, SetStateAction } from "react";
import Tooltip from "../../../atom/Tooltip";

interface TaskDetailViewToggleProps {
  toggleExpand: boolean;
  setIsModalNoteClicked: (isModalNoteClicked: boolean) => void;
  setToggleExpand: Dispatch<SetStateAction<boolean>>;
}

const TaskDetailViewToggle = ({
  toggleExpand,
  setIsModalNoteClicked,
  setToggleExpand,
}: TaskDetailViewToggleProps) => (
  <Tooltip content={!toggleExpand ? "Full" : "Collapse"}>
    <button
      className={clsx(
        "flex flex-shrink-0 items-center justify-center rounded-[5px] text-80 hover:bg-w-8-hover hover:text-white",
        {
          "h-6 w-6": !toggleExpand,
          "h-6 gap-2.5 px-1": toggleExpand,
        }
      )}
      onClick={() => {
        if (!toggleExpand) {
          setIsModalNoteClicked(false);
        }
        setToggleExpand((prev) => !prev);
      }}
    >
      {!toggleExpand ? <FullScreenIcon /> : <ExitFullScreenIcon />}
    </button>
  </Tooltip>
);

export default TaskDetailViewToggle;
